import React, { useState } from 'react';
import { Link } from "react-router-dom";
import RobotaxiLogin from "../../Images/LoginImage.png";
import { loginRequest } from "../utils/msalConfig";
import { signinRequest } from "../utils/msalConfigB2C";
import Cookies from 'js-cookie';
import { useMsalInstances } from "../utils/MsalInstancesContext";
import './LoginPage.css'
import logo from '../../Images/Logo-Horizontal-R.png'; // Adjust the path as necessary

const LoginPage = () => {
  const { azureADInstance, b2cInstance } = useMsalInstances();
  const [isLoginInProgress, setIsLoginInProgress] = useState(false);

  // Modified handler: set both localStorage and cookies for auth
  const setAuthAfterLogin = (token) => {
    Cookies.set("idToken", token);
    localStorage.setItem("isauth", "true");
  };

  const handleOwnerSiSU = async () => {
    if (isLoginInProgress) return;
    setIsLoginInProgress(true);
    try {
      const response = await b2cInstance.loginPopup(signinRequest);
      b2cInstance.setActiveAccount(response.account);
      sessionStorage.setItem("lastAccountId", response.account.homeAccountId);
      setAuthAfterLogin(response.accessToken);
      window.location.href = `${window.location.origin}/dashboard`;
      console.log("Login successful:", response);
    } catch (error) {
      // On login failure, reset auth
      localStorage.setItem("isauth", "false");
      Cookies.remove("idToken");
      console.error("Login failed:", error);
    } finally {
      setIsLoginInProgress(false);
    }
  };
  const handleEmployeeSignIn = async () => {
    if (isLoginInProgress) return;
    setIsLoginInProgress(true);
    try {
      const response = await azureADInstance.loginPopup(loginRequest);
      Cookies.set("msGraphToken", response.accessToken);
      setAuthAfterLogin(response.idToken);
      window.location.href = `${window.location.origin}/dashboard`;
      console.log("Login successful:", response);
    } catch (error) {
      localStorage.setItem("isauth", "false");
      Cookies.remove("idToken");
      console.error("Login failed:", error);
    } finally {
      setIsLoginInProgress(false);  // Reset the flag when the login process finishes
    }
  };
  return (
    <div className="container-fluid p-0">
      <div className="row m-0 vh-100">
        {/* Left Section: Image */}
        <div className="col-md-7 p-0">
          <img src={RobotaxiLogin} alt="Login" className="GeoparkingImage" />
          {/* <div className="version-label">Version.{process.env.REACT_APP_VERSION}</div> */}
        </div>

        {/* Right Section: Centered Content */}
        <div className="col-md-5 d-flex flex-column align-items-center justify-content-center text-center px-5">
          {/* Container to align logo and welcome text */}
          <div className="position-relative w-100 text-center">
            <img src={logo} alt="Logo" className="login-logo logo-align" />
            <h3 className="loginheader">Welcome to Geoparking</h3>
          </div>

          {/* Description */}
          <p className="newloginDescription">
            Effortlessly manage and access your parking spaces.<br />Choose your role to continue.
          </p>

          {/* Login Buttons (Same Width, White Text) */}
          <div className="text-center mt-4 w-50">
            <button className="btn btn-primary text-white w-100 px-4 py-2" onClick={handleOwnerSiSU}>
              Login as Parking Lot Owner/Employee
            </button>
          </div>

          <div className="text-center mt-3 w-50">
            <button className="btn btn-primary text-white w-100 px-4 py-2" onClick={handleEmployeeSignIn}>
              Login as GeoParking Employee
            </button>
          </div>

          {/* Signup Section */}
          <p className="mt-4">
            New to GeoParking?{" "}
            <Link to="/signup" className="joingeo">
              Join us now
            </Link>{" "}
            and be part of the future!
          </p>
          <div className="divhomePageButton mt-5 pt-3 text-center">
            <Link
              to="/Home"
              className="text-primary text-decoration-underline"
              style={{ cursor: 'pointer' }}
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LoginPage;
